//民族
let nationList = [
  { id: 1, label: "汉族" },
  { id: 2, label: "蒙古族" },
  { id: 3, label: "回族" },
  { id: 4, label: "藏族" },
  { id: 5, label: "维吾尔族" },
  { id: 6, label: "苗族" },
  { id: 7, label: "彝族" },
  { id: 8, label: "壮族" },
  { id: 9, label: "布依族" },
  { id: 10, label: "朝鲜族" },
  { id: 11, label: "满族" },
  { id: 12, label: "侗族" },
  { id: 13, label: "瑶族" },
  { id: 14, label: "白族" },
  { id: 15, label: "土家族" },
  { id: 16, label: "哈尼族" },
  { id: 17, label: "哈萨克族" },
  { id: 18, label: "傣族" },
  { id: 19, label: "黎族" },
  { id: 20, label: "傈僳族" },
  { id: 21, label: "佤族" },
  { id: 22, label: "畲族" },
  { id: 23, label: "高山族" },
  { id: 24, label: "拉祜族" },
  { id: 25, label: "水族" },
  { id: 26, label: "东乡族" },
  { id: 27, label: "纳西族" },
  { id: 28, label: "景颇族" },
  { id: 29, label: "柯尔克孜族" },
  { id: 30, label: "土族" },
  { id: 31, label: "达翰尔族" },
  { id: 32, label: "么佬族" },
  { id: 33, label: "羌族" },
  { id: 34, label: "布朗族" },
  { id: 35, label: "撒拉族" },
  { id: 36, label: "毛南族" },
  { id: 37, label: "仡佬族" },
  { id: 38, label: "锡伯族" },
  { id: 39, label: "阿昌族" },
  { id: 40, label: "普米族" },
  { id: 41, label: "塔吉克族" },
  { id: 42, label: "怒族" },
  { id: 43, label: "乌孜别克族" },
  { id: 44, label: "俄罗斯族" },
  { id: 45, label: "鄂温克族" },
  { id: 46, label: "德昂族" },
  { id: 47, label: "保安族" },
  { id: 48, label: "裕固族" },
  { id: 49, label: "京族" },
  { id: 50, label: "塔塔尔族" },
  { id: 51, label: "独龙族" },
  { id: 52, label: "鄂伦春族" },
  { id: 53, label: "赫哲族" },
  { id: 54, label: "门巴族" },
  { id: 55, label: "珞巴族" },
  { id: 56, label: "基诺族" },
];

//高考年份
let yearList = [
  { id: 2023, label: "2023" },
  { id: 2024, label: "2024" },
  { id: 2025, label: "2025" },
  { id: 2026, label: "2026" },
  { id: 2027, label: "2027" },
];

//升学类型
let educationTypeList = [
  { id: 1, label: "普通类" },
  { id: 2, label: "艺术类" },
  { id: 3, label: "体育类" },
  { id: 4, label: "特殊类" },
  { id: 5, label: "高职分类" },
];

//学生性质
let natureList = [
  { id: 1, label: "应届生" },
  { id: 2, label: "复读生（社会考生）" },
  { id: 3, label: "同等学历考生" },
];

//首选科目
let subjectList1 = [
  { id: 1, label: "物理" },
  { id: 2, label: "历史" },
];

//次选科目
let subjectList2 = [
  { id: 1, label: "化学" },
  { id: 2, label: "生物" },
  { id: 3, label: "地理" },
  { id: 4, label: "政治" },
];

//语种
let languageList = [
  { id: 1, label: "英语" },
  { id: 2, label: "日语" },
  { id: 3, label: "其他" },
];

//层次
let levelList = [
  { id: 1, label: "本科" },
  { id: 2, label: "专科" },
];
let arr = [
  { id: 1, label: "全部" },
  { id: 2, label: "本科" },
  { id: 3, label: "专科" },
];

//性质
let genreList = [
  { id: 1, label: "不限" },
  { id: 5, label: "985" },
  { id: 6, label: "211" },
  { id: 2, label: "公办" },
  { id: 4, label: "民办" },
  { id: 3, label: "独立学院" },
  { id: 7, label: "双一流" },
  { id: 8, label: "中外合作办学院校" },
  { id: 9, label: "港澳合作办学院校" },
];

//特色
let menList = [
  { id: 1, label: "不限" },
  { id: 2, label: "综合" },
  { id: 3, label: "理工" },
  { id: 4, label: "农林" },
  // { id: 5, label: "林业" },
  { id: 5, label: "医药" },
  { id: 6, label: "师范" },
  { id: 7, label: "语言" },
  { id: 8, label: "财经" },
  { id: 9, label: "政法" },
  { id: 10, label: "体育" },
  { id: 11, label: "艺术" },
  { id: 12, label: "民族" },
  { id: 13, label: "军事" },
];

//学科门类
let getMajorMl = [
  "不限",
  "哲学",
  "经济学",
  "法学",
  "教育学",
  "文学",
  "历史学",
  "理学",
  "工学",
  "农学",
  "医学",
  "管理学",
];

/**
 * 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true=立即执行(执行第一次)，false=非立即执行(执行最后一次)
 */
function debounce(func, wait = 100, immediate = false) {
  //只会初始化时执行一次
  var timeout;
  //此函数每次触发调用
  return function () {
    var context = this;
    var args = arguments;
    //多次触发则清除上一个定时器
    if (timeout) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow) func.apply(context, args);
    } else {
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    }
  };
}

//节流
function throttle(fn, _interval) {
  var last;
  var timer;
  var interval = _interval || 200;
  return function () {
    var th = this;
    var args = arguments;
    var now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.apply(th, args);
      }, interval);
    } else {
      last = now;
      fn.apply(th, args);
    }
  };
}

//数组与值作比较，有则删除，无则添加
function repel(array, value) {
  let index = array.findIndex((item) => {
    return item == value;
  });
  if (index !== -1) {
    array.splice(index, 1);
  } else {
    array.push(value);
  }
}
//添加选择开关
function arrayList(arr) {
  arr.forEach((item) => {
    item.isTrue = false;
    if (item.province) {
      item.label = item.province;
    }
  });
  arr.forEach((level, ind) => {
    if (ind === 0) {
      level.isTrue = true;
    }
  });
  return arr;
}
//默认选择开关
function provinceList(arr, province) {
  arr.forEach((item) => {
    item.isTrue = false;
    if (item.province) {
      item.label = item.province;
    }
  });
  arr.forEach((level, ind) => {
    if (level.label === province) {
      level.isTrue = true;
    }
  });
  return arr;
}
//跟换浏览器图标
function setFavicon (url)  {
  // 获取并移除原有的 favicon link（如果有多个，可能需要更精确的选择器）
  const oldLinks = document.querySelectorAll('link[rel="icon"]');
  for (let i = 0; i < oldLinks.length; i++) {
    oldLinks[i].parentNode.removeChild(oldLinks[i]);
  }
  // 创建新的 link 标签
  const link = document.createElement("link");
  link.type = "image/x-icon";
  link.rel = "icon";
  link.href = url;
  // 将新创建的 link 插入到 head 中
  document.head.appendChild(link);
}
//储存Cookie值
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}
//获取Cookie值
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) == 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return '';
}
function arrayTrue(val, array) {
  array.list[0].isTrue = false;
  val.isTrue = !val.isTrue;
  // 判断是否所有对象的 isTrue 都为 false
  let allFalse = array.list.every((item) => item.isTrue === false);
  if (allFalse) {
    array.list[0].isTrue = true;
  }
  if (val.label === "全部" || val.label === "不限") {
    array.list.forEach((item, ind) => {
      if (ind === 0) {
        item.isTrue = true;
      } else {
        item.isTrue = false;
      }
    });
  }
}
function getisTrue(array) {
  let arr = array.filter((item) => {
    return item.isTrue === true;
  });
  return arr.map((item) => item.label).join(",");
}


module.exports = {
  nationList,
  yearList,
  educationTypeList,
  natureList,
  subjectList1,
  subjectList2,
  languageList,
  levelList,
  genreList,
  menList,
  getMajorMl,
  arr,
  debounce,
  throttle,
  repel,
  arrayList,
  provinceList,
  setFavicon,
  setCookie,
  getCookie,
  arrayTrue,
  getisTrue,
};
